// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__2jCff","iconStyle":"Header_iconStyle__3jdoJ","dynamicHeaderRight":"Header_dynamicHeaderRight__2gexy","rightWrapper":"Header_rightWrapper__j1Xwi"};